import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAttachFile = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 18 18",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M14.7516 4.75732C13.8366 3.77181 12.353 3.77181 11.4379 4.75732L5.91506 10.7054C5.61004 11.0339 5.61004 11.5665 5.91506 11.895C6.22007 12.2235 6.71461 12.2235 7.01963 11.895L13.0948 5.35212L14.1993 6.54174L8.12419 13.0846C7.20914 14.0701 5.72554 14.0701 4.81049 13.0846C3.89543 12.0991 3.89543 10.5013 4.81049 9.51577L10.3333 3.5677C11.8584 1.92519 14.3311 1.92519 15.8562 3.5677C17.3813 5.21022 17.3813 7.87326 15.8562 9.51577L10.3333 15.4638C8.1982 17.7634 4.73648 17.7634 2.60135 15.4638C0.466218 13.1643 0.466218 9.43606 2.60135 7.13654L8.12419 1.18848L9.22876 2.37809L3.70592 8.32616C2.18082 9.96867 2.18082 12.6317 3.70592 14.2742C5.23101 15.9167 7.70367 15.9167 9.22876 14.2742L14.7516 8.32616C15.6667 7.34065 15.6667 5.74283 14.7516 4.75732Z",
		fill: "currentColor"
	})
});
export default SvgAttachFile;
